import * as angular from 'angular';
import { SvgManager } from '../../charting/SvgManager';
import { IOverlayModel, BackgroundOverlay } from '../../diagrams/index';
import { IDynamicCompileService } from '../services/dynamicCompileService';

export interface IwtBackgroundOverlayScope extends angular.IScope {
    series: IOverlayModel[];
    backgroundUrl: string;
    isGridVisible: boolean;
    isReadOnly: boolean;
    isZoomEnabled: boolean;
}

export class WtBackgroundOverlay {
    public static directiveId = 'wtBackgroundOverlay';
    template = '<div style="height: 100%; width: 100%;"><img style="display: none;" class="background-replace"/>'
        + '<svg class="background-overlay"></svg></div>';
    scope = {
        series: '=',
        backgroundUrl: '=',
        isGridVisible: '=',
        isReadOnly: '=',
        isZoomEnabled: '='
    };
    replace = true;

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        this.link.bind(this);
    }

    link = ($scope: IwtBackgroundOverlayScope, element: angular.IAugmentedJQuery, attrs) => {
        //TODO svg manager
        const id = attrs['id'];
        if (!id) {
            console.error('An id is required in order to use wtBackgroundOverlay');
        } else {
            element.attr('id', id);
            const mgr = new SvgManager(id, {
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0
            });
            const chart = new BackgroundOverlay(mgr);
            this.initWatchers($scope, chart, element);
        }
    }

    private initWatchers($scope: IwtBackgroundOverlayScope, chart: BackgroundOverlay, element: angular.IAugmentedJQuery) {
        $scope.$watch(() => $scope.series, (newValue) => {
            if (newValue) {
                chart.updateSeries(newValue);
                this._dynamicCompileService.compileGroup(element, $scope);
            }
        }, true);

        $scope.$watch(() => $scope.backgroundUrl, (newValue: string) => {
            if (newValue) {
                const query = element.children('img');
                query.css('display', 'block');
                const measure = <any>query[0];
                measure.src = newValue;
                chart.updateBackground(newValue, measure, () => {
                    query.css('display', 'none');
                    this._dynamicCompileService.compileGroup(element, $scope);
                });
            }
        }, true);

        $scope.$watch(() => $scope.isGridVisible, (newValue: boolean) => {
            if (newValue !== null && newValue !== undefined) {
                chart.isGridVisible(newValue);
            }
        });

        $scope.$watch(() => $scope.isReadOnly, (newValue: boolean) => {
            if (newValue !== null && newValue !== undefined) {
                chart.isReadOnly(newValue);
            }
        });

        $scope.$watch(() => $scope.isZoomEnabled, (newValue: boolean) => {
            if (newValue !== null && newValue !== undefined) {
                chart.isZoomEnabled(newValue);
            }
        });

        $scope.$on('wt-background-overlay-fit', () => {
            chart.fit();
        });
    }
}